import Vue from 'vue'
import http from '@/libs/http'
import store from '@/store'
import VueRouter from 'vue-router'
import MainLayout from '@/layouts/Main'
import moment from 'moment'

Vue.use(VueRouter)

const router = new VueRouter({
  // linkActiveClass: 'active',
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/user/signin',
      component: () => import('@/pages/user/Signin')
    },
    {
      path: '/',
      meta: { auth: true, title: 'APIs' },
      component: MainLayout,
      children: [
        { path: '/', component: () => import('@/pages/api/Index') }
      ]
    },
    {
      path: '/api',
      meta: { auth: true, title: 'APIs' },
      component: MainLayout,
      children: [
        { path: '', meta: { title: 'All' }, component: () => import('@/pages/api/Index') },
        {
          path: 'create',
          meta: { title: 'Create' },
          name: 'api-create',
          component: () => import('@/pages/api/Create')
        },
        {
          path: 'update/:id',
          meta: { title: 'Update' },
          name: 'api-update',
          component: () => import('@/pages/api/Update')
        },
        { path: 'play/:id', meta: { title: 'Play' }, name: 'api-play', component: () => import('@/pages/api/Play') },
        {
          path: 'filter/:id',
          meta: { title: 'Filter' },
          name: 'api-filter',
          component: () => import('@/pages/api/Filter')
        },
        {
          path: 'api-suggest/:id',
          meta: { title: 'Suggests' },
          name: 'api-suggest',
          component: () => import('@/pages/api/SuggestForm')
        },
        {
          path: 'suggest-play/:id',
          meta: { title: 'Suggest Play' },
          name: 'api-suggest-play',
          component: () => import('@/pages/api/SuggestPlay')
        },
        { path: 'create', meta: { title: 'Create' }, name: 'api-clone', component: () => import('@/pages/api/Create') },
        { path: 'create', meta: { title: 'Create' }, name: 'api-clear', component: () => import('@/pages/api/Create') },
        { path: 'create', meta: { title: 'Create' }, name: 'api-log', component: () => import('@/pages/api/Create') },
        { path: 'create', meta: { title: 'Create' }, name: 'api-delete', component: () => import('@/pages/api/Create') }
      ]
    },
    {
      path: '/crud',
      meta: { auth: true, title: 'CRUDs' },
      component: MainLayout,
      children: [
        { path: '', meta: { title: 'All' }, component: () => import('@/pages/crud/Index') },
        { path: 'create', meta: { title: 'Create' }, component: () => import('@/pages/crud/Create') },
        {
          path: 'update/:id',
          meta: { title: 'Update' },
          name: 'crud-update',
          component: () => import('@/pages/crud/Update')
        },
        { path: 'play/:id', meta: { title: 'Play' }, name: 'crud-play', component: () => import('@/pages/crud/Play') }
      ]
    },
    {
      path: '/api-group',
      meta: { auth: true, title: 'API Group' },
      component: MainLayout,
      children: [
        { path: '', meta: { title: 'All' }, component: () => import('@/pages/api-group/Index') },
        { path: 'create', meta: { title: 'Create' }, component: () => import('@/pages/api-group/Create') },
        {
          path: 'update/:id',
          meta: { title: 'Update' },
          name: 'api-group-update',
          component: () => import('@/pages/api-group/Update')
        }
      ]
    },
    {
      path: '/database',
      meta: { auth: true, title: 'Database' },
      component: MainLayout,
      children: [
        { path: '', meta: { title: 'All' }, component: () => import('@/pages/database/Index') },
        { path: 'create', meta: { title: 'Create' }, component: () => import('@/pages/database/Create') },
        {
          path: 'update/:id',
          meta: { title: 'Update' },
          name: 'database-update',
          component: () => import('@/pages/database/Update')
        }
      ]
    },
    {
      path: '/endpoint',
      meta: { auth: true, title: 'Endpoint' },
      component: MainLayout,
      children: [
        { path: '', meta: { title: 'All' }, component: () => import('@/pages/endpoint/Index') },
        { path: 'create', meta: { title: 'Create' }, component: () => import('@/pages/endpoint/Create') },
        {
          path: 'update/:id',
          meta: { title: 'Update' },
          name: 'endpoint-update',
          component: () => import('@/pages/endpoint/Update')
        }
      ]
    },
    {
      path: '/token',
      meta: { auth: true, title: 'Token' },
      component: MainLayout,
      children: [
        { path: '', meta: { title: 'All' }, component: () => import('@/pages/token/Index') },
        { path: 'create', meta: { title: 'Create' }, component: () => import('@/pages/token/Create') },
        {
          path: 'update/:id',
          meta: { title: 'Update' },
          name: 'token-update',
          component: () => import('@/pages/token/Update')
        },
        {
          path: 'permission/:id',
          meta: { title: 'Permission' },
          name: 'token-permission',
          component: () => import('@/pages/token/Permission')
        }
      ]
    },
    {
      path: '/log',
      meta: { auth: true, title: 'Log' },
      component: MainLayout,
      children: [
        { path: '', meta: { title: 'All' }, component: () => import('@/pages/log/Index') }
      ]
    },
    {
      path: '/template',
      meta: { auth: true },
      component: MainLayout,
      children: [
        { path: 'block-styles', component: () => import('@/pages/template/BlockStyles') },
        { path: 'block-options', component: () => import('@/pages/template/BlockOptions') }
      ]
    },
    { path: '*', component: () => import('@/pages/error/404') }
  ]
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('api-platform-token')
  const tokenJson = JSON.parse(token)
  let isExpire = false
  if (tokenJson) {
    const checkExpire = moment(new Date(tokenJson.expire)).fromNow()
    isExpire = checkExpire.includes('ago')
  }

  // Check Auth path => true return login and false = pass
  if (to.matched.some((record) => record.meta.auth)) {
    if (isExpire) {
      localStorage.removeItem('api-platform-jwt')
      localStorage.removeItem('api-platform-token')
      next({
        path: '/user/signin',
        query: { redirect: to.fullPath }
      })
    } else {
      if (tokenJson) {
        http.defaults.headers.common['token'] = store.getters['user/token']
        next()
      } else {
        next({
          path: '/user/signin',
          query: { redirect: to.fullPath }
        })
      }
    }
  } else {
    next()
  }
})

// router.beforeEach((to, from, next) => {
//   if (to.matched.some(record => record.meta.auth)) {
//     if (!store.getters['user/isAuthenticated']) {
//       next({
//         path: '/user/signin',
//         query: { redirect: to.fullPath }
//       })
//     } else {
//       http.defaults.headers.common['token'] = store.getters['user/token']
//       next()
//     }
//   } else {
//     next()
//   }
// })

export default router
